<template>
  <view-post/>
</template>

<script>
import ViewPost from '../components/ViewPost/index'
export default {
  components: {ViewPost  },

}
</script>

<style>

</style>
